<template>
  <nav class="header-nav">
    <div class="container">
      <router-link :class="{'active': activeLink == 'safety'}" to="/safety">Chất lượng của Fudizi</router-link><!--富地滋的品質-->
      <router-link :class="{'active': activeLink == 'manufacturing'}" to="/safety/manufacturing">an toàn sản phẩm</router-link><!--製品的安全性-->
      <router-link :class="{'active': activeLink == 'patents'}" to="/safety/patents">Thông tin bằng sáng chế</router-link><!--專利權資訊-->
    </div>
  </nav>
</template>
<script>
export default {
  name: "SafetyHeaderNav",
  props: ["activeLink"],
};
</script>
